import routes from 'src/config/routes'
import { useQuery, UseQueryResult } from 'react-query'
import { getCategorizedTreatments } from 'src/services/api/treatment'
import captureExceptionWithResponse from 'src/services/sentry'
import { CategorizedTreatment } from '@customTypes/CategorizedTreatment'
import { useChoiceState } from '@context/ChoiceContext'
import { findTreatmentInCategorizedTreatments } from 'src/helpers/treatment'
import { useHistory } from 'react-router-dom'
import { useConfig } from '@context/ConfigurationContext'
import { AppMode, RegularFlowQueryParams } from '@customTypes/Generic'
import queryString from 'query-string'

const useCategorizedTreatments: () => UseQueryResult<CategorizedTreatment[]> = () => {
  const { treatmentBundleTypeReferenceId } = useChoiceState()
  const history = useHistory()
  const { mode, clinicId } = useConfig()
  const isRegularBookingMode = mode === AppMode.NORMAL
  const params: RegularFlowQueryParams = queryString.parse(window.location.search)
  const { treatmentBundleReferenceId } = params

  const result = useQuery(['categorizedTreatments', clinicId], () => getCategorizedTreatments(clinicId), {
    retry: 6,
    enabled: !!clinicId,
    onSuccess(data) {
      if (treatmentBundleTypeReferenceId && isRegularBookingMode && treatmentBundleReferenceId) {
        const treatment = findTreatmentInCategorizedTreatments(data || [], treatmentBundleTypeReferenceId || '')

        if (!treatment) {
          history.push(routes.treatment)
        }
      }
    },
    onError() {
      history.push(routes.treatment)
    },
  })

  if (result.isError) {
    captureExceptionWithResponse('Something went wrong while fetching categorized treatments', result.error)
  }

  return result
}

export default useCategorizedTreatments
